import { getFreespinsEndAction } from 'automaton/actions/FreespinEndAction'
import { getBetState } from 'automaton/states/BetState'
import { getFreebetAddState } from 'automaton/states/FreebetAddState'
import { getFreeBetState } from 'automaton/states/FreeBetState'
import { spinSettings } from 'settings/custom/reels'

export function getFreespinEndState() {
  const name = 'FS-END'
  const freeBetModel = game.models.FreebetsModel.get()
  const actions = [getFreespinsEndAction()]
  if(spinSettings.hasOwnProperty('gamble') && spinSettings.gamble){
    game.models.GambleModel.setIsGamble(true)
  }
  const transition =   () => freeBetModel.add ? getFreebetAddState() : freeBetModel.rest ? getFreeBetState() : getBetState()

  return {
    name,
    actions,
    transition,
  }
}
